module.exports = __webpack_public_path__ + "static/navlogo-054def232fad24448277901775d4bdce.png";